import { Component } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { GlobalWindow } from '../../../main.window';
import { Subscription } from 'rxjs';
import { IAccount } from '../../../interfaces/graph-types';

declare let window: GlobalWindow;

@Component({
  selector: '[account-dashboard]',
  template: require('./account-dashboard.component.pug'),
  styles: [require('./account-dashboard.component.css').toString()],
})
export class AccountDashboardComponent {
  img_empty = require('./empty.png').default;

  accountId: string;

  sub: Subscription = null;
  account: IAccount = null;

  cssHasInboxes = 'none';
  cssHasCandidates = 'none';
  cssHasFunnels = 'none';
  cssHasApplications = 'none';

  // -------------------------------------------------------------------
  constructor(
    private watchAccount: WatchAccountService,
    private accountService: AccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.accountId = this.watchAccount.accountId().getValue();

    this.sub = this.accountService.getStarted(this.accountId).subscribe(res => {
      this.account = res;

      if (this.account.hasInboxes) {
        this.cssHasInboxes = 'line-through';
      }
      if (this.account.hasCandidates) {
        this.cssHasCandidates = 'line-through';
      }
      if (this.account.hasFunnels) {
        this.cssHasFunnels = 'line-through';
      }
      if (this.account.hasApplications) {
        this.cssHasApplications = 'line-through';
      }
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  completed() {
    if (!this.account) {
      return false;
    }
    return false;
  }

  // -------------------------------------------------------------------
  backgroundImg() {
    return 'url(' + this.img_empty + ')';
  }
}
